/* HX CART LOGIN CTA – stable (no MutationObserver, retry title up to 3s) */
(function () {

const i18n = (window.hxI18n && window.hxI18n.cart) || {};
const txtWhatsApp = i18n.whatsapp || 'WhatsApp Kanal abonnieren und 5% sparen';
const txtLogin = i18n.login_for_dealer_prices || 'Einloggen für Händlerpreise und Vorteile.';
const txtHint = i18n.logged_in_hint || '✓ Du bist eingeloggt und solltest deine Rabatte sehen';

  function isCartPage() {
    return /\/cart\/?$/.test(location.pathname);
  }
  if (!isCartPage()) return;

  function isLoggedIn() {
    return !!window.ShopifyAnalytics?.meta?.page?.customerId;
  }

  function ensureStyles() {
    if (document.getElementById('hx-cart-login-styles')) return;
    const style = document.createElement('style');
    style.id = 'hx-cart-login-styles';
    style.textContent = `
      .hx-cart-cta-wrap{ margin-bottom:16px; }
      .hx-cart-cta-row{ display:grid; grid-template-columns:1fr 1fr; gap:12px; align-items:stretch; max-width:900px; }
      .hx-cart-cta-row a{
        display:flex !important; align-items:center; justify-content:center;
        width:100% !important; min-height:44px; padding:12px 20px;
        font-weight:600; border-radius:8px; text-decoration:none;
        line-height:1.5; white-space:normal; text-align:center;
        border:none !important;
      }
      @media (max-width: 640px){ .hx-cart-cta-row{ grid-template-columns:1fr; } }
    `;
    document.head.appendChild(style);
  }

  function injectCTA() {
    ensureStyles();

    const title = document.querySelector('.js-cart-title');
    if (!title) return false; // <- wichtig für Retry

    let wrap = document.querySelector('.hx-cart-cta-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'hx-cart-cta-wrap';
      title.parentNode.insertBefore(wrap, title);
    }

    const loggedIn = isLoggedIn();

    wrap.innerHTML = loggedIn
  ? `<p style="color:#2c7e3f;font-size:14px;margin:0 0 8px 0;">${txtHint}</p>`
  : `<div class="hx-cart-cta-row">
       <a href="/account/login" style="background:#ffed00;color:#000;border:none;">
         ${txtLogin}
       </a>
       <a href="https://whatsapp.com/channel/0029Varb8RwFi8xgYYGTBg0V" style="background:#25D366;color:#fff;border:none;">
         ${txtWhatsApp}
       </a>
     </div>`;

    return true;
  }

  // Debounce damit wir nicht mitten in Theme-Init reinfunken
  let t;
  function runSoon() {
    clearTimeout(t);
    t = setTimeout(runWithRetry, 80);
  }

  // Retry bis .js-cart-title da ist (max ~3 Sekunden)
  function runWithRetry() {
    const maxTries = 30;
    let tries = 0;

    const tick = () => {
      tries += 1;
      const ok = injectCTA();
      if (ok || tries >= maxTries) return;
      setTimeout(tick, 100);
    };

    tick();
  }

  document.addEventListener('DOMContentLoaded', runSoon);

  // wichtig für Reload/BFCache
  window.addEventListener('pageshow', runSoon);

  // falls Shopify Sections Events feuert
  document.addEventListener('shopify:section:load', runSoon);
})();
